export const citizenAreaPathName = 'citizen';
export const citizenDetailsTabPathName = 'details';

// ServiceProvider-specific pathnames
export const serviceProviderAreaPathName = 'serviceprovider';
export const serviceProviderDetailsTabPathName = 'details';

// Diary (serviceprovider specific)
export const diaryTabLabel = 'Dagbog og dokumenter';
export const diaryTabPathName = 'diary';
export const diaryNotePathName = 'note';
export const diaryNoteCreate = 'create';
export const diaryNoteView = 'view';

// Journal note attachments
export const journalNoteAttachmentDownloadPathName = 'note/files/:fileId';

// Citizen person contact
export const citizenPersonContactPathName = 'citizen-person-contact/:contactId?';

// Communication
export const communicationTabPathName = 'communication';

// Medical collaboration (Lægeoplysninger) — landing tab for SLS-only users
export const medicalCollaborationTabPathName = 'medical-collaboration';

// ServiceProvider specific letter guide
export const socialCitizenLetterGuide = 'guide-letter-social-provider';

// Letter guide for SLS executors, whose letters belong to the udførerenhed rather than a bestilling
export const medicalCollaboratorLetterGuide = 'guide-letter-medical-collaborator';

// Assignment
export const viewAssignmentPathName = 'view-assignment/:assignmentId';
export const supportAssessmentPathSegment = 'support-assessment';
export const viewAssignmentSupportAssessmentPathName = `${viewAssignmentPathName}/${supportAssessmentPathSegment}`;
export const createAssignmentPathName = 'create-assignment';

// Temporary address
export const temporaryAddressPath = 'temporary-address';

// Counseling inquiry
export const counselingInquiryPathName = 'counseling-inquiry';

// Efforts
export const interventionObjectiveStatusPathName = 'intervention-objective-status';

// Deep-link query params for the partial objectives tab
export const editPartialObjectiveParam = 'editPartialObjective';
export const createFollowupForPartialObjectiveParam = 'createFollowupForPartialObjective';
